import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Voir / consulter — œil duotone */
export const ViewIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Pupille menthe */}
      <circle cx="12" cy="12" r="3" fill="var(--equiply-icon-bg)" />
      {/* Œil */}
      <path
        d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Iris contour */}
      <circle cx="12" cy="12" r="3" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Reflet */}
      <circle cx="13.5" cy="10.5" r="0.7" fill="hsl(var(--background))" />
    </svg>
  ),
);
ViewIcon.displayName = "ViewIcon";
